import moment from 'moment'

export function formatPeriodExecution(periodExecution) {
    const d = moment.duration(periodExecution, 'hours')
    return d.format('D [days] H [hrs]', {
        trim: 'both'
    })
}

export function periodExecutionToDays(periodExecution) {
    const d = moment.duration(periodExecution, 'hours')
    return d.format('D', {
        trim: 'both'
    })
}

export function reformatDate(value, strict = false, fromFormat = 'YYYY-MM-DD', toFormat = 'DD.MM.YYYY') {
    if (value === null) {
        return value
    }

    const result = moment(value, fromFormat)

    if (!result.isValid()) {
        if (!strict) {
            return value
        }

        return 'Invalid date format'
    }

    return result.format(toFormat)
}
